import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";
import SidebarItem from "components/NewSidebar/components/SidebarContent/components/SidebarItem";

import {ReactComponent as LogoutIcon} from "assets/img/logout.svg";
import {red500} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {SidebarContext} from "../../../SidebarContext";

function LogoutButton(props) {
    const {closeSidebar} = useContext(SidebarContext);

    return (
        <SidebarItem
            isTopLevel={true}
            icon={<LogoutIcon />}
            to={MarketplaceRoutes.LOGOUT}
            onClick={() => closeSidebar()}
            style={{
                color: red500,
            }}
        >
            <FormattedMessage id='sidebar.logout' />
        </SidebarItem>
    );
}

export default LogoutButton;
